import { EmissionFactor } from "./emission-factor.model";

export class CountryEmissionFactor {
	electric: EmissionFactor[];
	diesel: EmissionFactor[];
	gas: EmissionFactor[];
	averageCost: number;
	averageCostState: boolean;
}
